<template>
  <f7-page class="page-mission has-footer">
    <f7-navbar :sliding="false">
      <f7-nav-left back-link="Trở lại"></f7-nav-left>
      <f7-nav-title sliding>BẢNG NHIỆM VỤ</f7-nav-title>
    </f7-navbar>
    <f7-list inset v-if="badges.length > 0" media-list>
      <f7-list-item v-for="(badge, idx) in badges" :key="idx"
                    :title="badge.reward_title"
                    :text="`+${badge.reward_amount} ${badge.reward_type}`"
                    checkbox
                    :checked="badge.reward_status"
                    :readonly="true"
                    :disabled="true"
      >
      </f7-list-item>
    </f7-list>
    <Footer/>
  </f7-page>
</template>
<style scoped>
.mission-board-header {
  margin-top : -40px;
}
.mission.card {
  border-radius : 14px;
}
.mission .card-header {
  background              : #FFF3CD;
  color                   : #842029;
  font-weight             : bold;
  border-top-left-radius  : 14px;
  border-top-right-radius : 14px;
}
</style>
<script>
import Footer from "@/components/Footer";
export default {
  components: {
    Footer
  },
  data(){
    return {
      badges:[]
    }
  },
  methods:{
    getBadges(){
      this.$store.dispatch('getBadges').then((data) => {
        console.log(data);
        this.badges = data;
      });
    }
  },
  mounted(){
    this.getBadges();
  }
};
</script>
